import { useTranslation } from 'react-i18next';

import { AltaAccessSvg } from 'components/svgs/AltaAccessSvg';
import { AltaVideoSvg } from 'components/svgs/AltaVideoSvg';
import { AltaDmpSvg } from 'components/svgs/AltaDmpSvg';
import { AltaMailroomSvg } from 'components/svgs/AltaMailroomSvg';
import { AltaSosSvg } from 'components/svgs/AltaSosSvg';
import { AltaVisitorSvg } from 'components/svgs/AltaVisitorSvg';
import { AltaAdminSvg } from 'components/svgs/AltaAdminSvg';
import { AltaWearSvg } from 'components/svgs/AltaWearSvg';
import { useFeatureFlag } from 'utils/customHooks/useFeatureFlag';
import { getOpParams } from 'utils/getOpParams';

import { AppSwitcherButton } from './AppSwitcherButton';

import './AppSwitcherMenu.scss';

interface AppSwitcherMenuProps {
  handleAwareLogin?(): Promise<void>;
  handleDmpLogin?(): Promise<void>;
  handleNavigateToMailroom?(): void;
  handleNavigateToAccess(): void;
  handleNavigateToSos(): void;
  handleNavigateToVisitor?(): void;
  handleNavigateToAdmin(): void;
}

export const AppSwitcherMenu = ({
  handleNavigateToVisitor,
  handleNavigateToSos,
  handleNavigateToAdmin,
  handleAwareLogin,
  handleDmpLogin,
  handleNavigateToMailroom,
  handleNavigateToAccess,
}: AppSwitcherMenuProps) => {
  const { t } = useTranslation();
  const { orgId } = getOpParams();
  const { value: isSosEnabled } = useFeatureFlag<boolean>(
    'IS_SOS_ENABLED',
    orgId,
  );
  const { value: isAdminEnabled } = useFeatureFlag<boolean>(
    'IS_ADMIN_ENABLED',
    orgId,
  );
  const { value: isWearEnabled } = useFeatureFlag<boolean>(
    'IS_WEAR_ENABLED',
    orgId,
  );

  return (
    <div className="app-switcher-menu">
      <AppSwitcherButton
        label={t('Access')}
        gtm="app-switcher-button-access"
        onClick={handleNavigateToAccess}
        icon={<AltaAccessSvg className="app-switcher-button__icon" />}
      />
      {isSosEnabled && (
        <AppSwitcherButton
          label={t('SOS')}
          gtm="app-switcher-button-sos"
          onClick={handleNavigateToSos}
          icon={<AltaSosSvg className="app-switcher-button__icon" />}
        />
      )}
      {handleDmpLogin ? (
        <AppSwitcherButton
          label={t('DMP')}
          gtm="app-switcher-button-dmp"
          onClick={handleDmpLogin}
          icon={<AltaDmpSvg className="app-switcher-button__icon" />}
        />
      ) : null}
      {handleNavigateToMailroom ? (
        <AppSwitcherButton
          label={t('Mailroom')}
          gtm="app-switcher-button-mailroom"
          onClick={handleNavigateToMailroom}
          icon={<AltaMailroomSvg className="app-switcher-button__icon" />}
        />
      ) : null}
      {handleNavigateToVisitor ? (
        <AppSwitcherButton
          label="Visitor"
          gtm="app-switcher-button-visitor"
          onClick={handleNavigateToVisitor}
          icon={<AltaVisitorSvg className="app-switcher-button__icon" />}
        />
      ) : null}
      {isAdminEnabled && (
        <AppSwitcherButton
          label={t('Admin')}
          gtm="app-switcher-button-admin"
          onClick={handleNavigateToAdmin}
          icon={<AltaAdminSvg className="app-switcher-button__icon" />}
        />
      )}
      {handleAwareLogin ? (
        <AppSwitcherButton
          label={t('Video')}
          gtm="app-switcher-button-video"
          onClick={handleAwareLogin}
          icon={<AltaVideoSvg className="app-switcher-button__icon" />}
        />
      ) : null}
      {isWearEnabled && (
        <AppSwitcherButton
          label={t('Wear')}
          gtm="app-switcher-button-wear"
          onClick={() =>
            window.open(
              'https://www.motorolasolutions.com/en_us/video-security-access-control/body-worn-cameras/safetycam.html',
              '_self',
              'noopener,noreferrer',
            )
          }
          icon={<AltaWearSvg className="app-switcher-button__icon" />}
        />
      )}
    </div>
  );
};
